export interface SkillMdParts {
  frontmatterSource: string | null;
  prose: string;
  workflowSource: string | null;
  workflowBlockCount: number;
  unterminated: boolean;
}

// A code fence: up to three spaces, three or more backticks or tildes, then an
// optional info string. Four spaces make an indented code line, not a fence.
// A backtick fence's info string has no backtick.
const FENCE = /^ {0,3}(`{3,}(?=[^`]*$)|~{3,})(.*)$/;

const FRONTMATTER = /^---[ \t]*\n([\s\S]*?)\n---[ \t]*(?:\n|$)/;

export function splitSkillMd(md: string): SkillMdParts {
  const text = md.replace(/^\uFEFF/, '').replace(/\r\n?/g, '\n');
  const fm = FRONTMATTER.exec(text);
  const body = fm ? text.slice(fm[0].length) : text;
  const proseLines: string[] = [];
  const blocks: string[][] = [];
  let current: string[] | null = null;
  // A code fence in the prose, such as an example of the format, is prose even when it holds a workflow line.
  let proseFence: { char: string; length: number } | null = null;
  for (const line of body.split('\n')) {
    const fence = FENCE.exec(line.trimEnd());
    if (current === null && proseFence) {
      if (fence && fence[2] === '' && fence[1][0] === proseFence.char && fence[1].length >= proseFence.length) {
        proseFence = null;
      }
      proseLines.push(line);
    } else if (current === null && line.trimEnd() === '```workflow') {
      current = [];
      blocks.push(current);
    } else if (current !== null && line.trimEnd() === '```') {
      current = null;
    } else if (current !== null) {
      current.push(line);
    } else {
      if (fence) proseFence = { char: fence[1][0], length: fence[1].length };
      proseLines.push(line);
    }
  }
  return {
    frontmatterSource: fm ? fm[1] : null,
    prose: proseLines
      .join('\n')
      .replace(/\n{3,}/g, '\n\n')
      .trim(),
    workflowSource: blocks.length > 0 ? blocks[0].join('\n').trimEnd() : null,
    workflowBlockCount: blocks.length,
    unterminated: current !== null,
  };
}

export function joinSkillMd(frontmatterSource: string, prose: string, workflowSource: string | null): string {
  const parts = [`---\n${frontmatterSource.trimEnd()}\n---`];
  if (prose.trim() !== '') parts.push(prose.trim());
  if (workflowSource !== null) parts.push('```workflow\n' + workflowSource.trimEnd() + '\n```');
  return parts.join('\n\n') + '\n';
}
